export const CANVAS_WIDTH = 800;
export const CANVAS_HEIGHT = 600;
export const PLAYER_WIDTH = 85;
export const PLAYER_HEIGHT = 215;
export const ENEMY_WIDTH = 85;
export const ENEMY_HEIGHT = 215;
export const SWORD_RANGE = 140;